import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import { Observable, map } from 'rxjs'
import { GovernmentBusinessAPIModel, ModuleDashboardAPIModel, PaginatedAPI } from 'src/app/models/api.model'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/store/state/app.state'
import { GovernmentBusinessDashboardModel } from 'src/app/models/model'
import {
  delete_government_business_details,
  fetch_dashboard_data,
  fetch_government_business_details,
  save_government_business_action,
  update_government_business_action
} from 'src/app/store/action/government-business.action'
import {
  getGovernmentBusinessDashboardInfo,
  getGovernmentBusinessDetails
} from '../../store/selector/government-business.selector'

@Injectable({
  providedIn: 'root'
})
export class GovernmentBusinessService {
  constructor(private webservice: WebService, private appState: Store<AppState>) {}

  dispatchFetchDashboardData(days: number, sortBy: string, sortOrder: string) {
    this.appState.dispatch(fetch_dashboard_data({ days, sortBy, sortOrder }))
  }

  invokeDashboardApi = (days: number, sortBy: string, sortOrder: string) => {
    const endPoint = `${ServiceUrlConstants.API_GOVERNMENT_BUSINESS_DASHBOARD}?days=${days}&sortBy=${sortBy}&sortOrder=${sortOrder}`
    return this.webservice.get(endPoint).pipe(map((data: ModuleDashboardAPIModel) => data))
  }

  getDashboardDataSelector(): Observable<GovernmentBusinessDashboardModel> {
    return this.appState.select(getGovernmentBusinessDashboardInfo)
  }

  dispatchSaveGovernmentBusinessAction(governmentBusiness: GovernmentBusinessAPIModel, files: File[], routeTo: string) {
    this.appState.dispatch(save_government_business_action({ governmentBusiness, files, routeTo }))
  }

  callSaveApi = (governmentBusiness: GovernmentBusinessAPIModel, files: File[]) => {
    const endPoint = ServiceUrlConstants.API_SAVE_GOVERNMENT_BUSINESS
    const formData: FormData = new FormData()
    const governmentBusinessBlob = new Blob([JSON.stringify(governmentBusiness)], { type: 'application/json' })
    formData.append('governmentBusiness', governmentBusinessBlob)
    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append('documentList', files[i])
      }
    }

    return this.webservice
      .post(endPoint, formData, null, [], false)
      .pipe(map((data: GovernmentBusinessAPIModel) => data))
  }

  dispatchFetchDetailsAction(id: string) {
    return this.appState.dispatch(fetch_government_business_details({ id }))
  }

  callDetailsApi = (id: string) => {
    const endPoint = `${ServiceUrlConstants.API_FETCH_GOVERNMENT_BUSINESS_DETAILS}${id}`
    return this.webservice.get(endPoint).pipe(map((data: GovernmentBusinessAPIModel) => data))
  }

  getGovernmentBusinessDetailsFromStore = (): Observable<GovernmentBusinessAPIModel> => {
    return this.appState.select(getGovernmentBusinessDetails())
  }

  dispatchUpdateGovernmentBusinessAction(
    governmentBusiness: Partial<GovernmentBusinessAPIModel>,
    id: string,
    files: File[],
    routeTo: string
  ) {
    this.appState.dispatch(update_government_business_action({ governmentBusiness, id, files, routeTo }))
  }

  callUpdateApi = (governmentBusiness: Partial<GovernmentBusinessAPIModel>, id: string, files: File[]) => {
    const endPoint = ServiceUrlConstants.API_GOVERNMENT_BUSINESS_UPDATE + id
    const formData: FormData = new FormData()
    const governmentBusinessBlob = new Blob([JSON.stringify(governmentBusiness)], { type: 'application/json' })
    formData.append('governmentBusiness', governmentBusinessBlob)
    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append('documentList', files[i])
      }
    }

    return this.webservice
      .put(endPoint, formData, null, [], false)
      .pipe(map((data: GovernmentBusinessAPIModel) => data))
  }

  dispatchDeleteGovernmentBusinessDetailsAction() {
    return this.appState.dispatch(delete_government_business_details())
  }

  invokeGovernmentSummaryAPI = (queryParams: { key: string; value: string }[], searchRequestBody) => {
    return this.webservice
      .post(ServiceUrlConstants.API_GOVERNMENT_BUSINESS_SUMMARY_LIST, searchRequestBody, null, queryParams)
      .pipe(map((data: PaginatedAPI<GovernmentBusinessAPIModel>) => data))
  }
}
